import gql from "graphql-tag";

// Local type
import EvaluationAnswerFields from "./EvaluationAnswerFields"

// Foreign types
import SimpleUserFields from "../User/SimpleUserFields"
import EvaluationTemplateFields from "../EvaluationTemplate/EvaluationTemplateFields";

export default gql`
  fragment EvaluationFields on Evaluation {
    id
    createdAt
    updatedAt
    createdBy
    templateId
    answers {
      ...EvaluationAnswerFields
    }
    createdByUser {
      ...SimpleUserFields
    }
    createdByEmail
    summary {
      templateName
      sections {
        sectionId
        sectionName
        scorePercent
        scoreTotal
        scorePossible
        scorePerAnswer {
          score
          possibleScore
          questionId
          questionName
          answer
        }
      }
      scoreTotal
      scorePossible
      scorePercent
    }
    template {
      ...EvaluationTemplateFields
    }
  }
  ${EvaluationAnswerFields}
  ${SimpleUserFields}
  ${EvaluationTemplateFields}
`